import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import clsx from 'clsx';
import classes from './FieldWrapper.module.css';
export const FieldWrapper = ({ htmlType = 'div', label, children, labelClassName, className, }) => {
    return React.createElement(htmlType, { className: clsx(classes.wrapper, className) }, _jsxs(_Fragment, { children: [_jsx("span", { className: clsx(classes.label, labelClassName), children: label }), children] }));
};
